import { consola } from 'consola'

export const logger = consola.withTag('app')

export default logger
